import React from 'react'
import {Icon} from '@chakra-ui/react'

const LiveChatIcon = (props) => {
    return (
        <Icon viewBox="0 0 48 48" {...props}>
            <path
                d="M7.77376 29.3006C8.44236 29.3006 8.98297 28.76 8.98297 28.0923C8.98297 27.4247 8.44236 26.884 7.77376 26.884C7.10706 26.884 6.56645 27.4247 6.56645 28.0923C6.56645 28.76 7.10706 29.3006 7.77376 29.3006Z"
                fill="currentColor"
            />
            <path
                d="M13.159 28.0923C13.159 28.76 12.6184 29.3006 11.9498 29.3006C11.2831 29.3006 10.7425 28.76 10.7425 28.0923C10.7425 27.4247 11.2831 26.884 11.9498 26.884C12.6184 26.884 13.159 27.4247 13.159 28.0923Z"
                fill="currentColor"
            />
            <path
                d="M17.335 28.0923C17.335 28.76 16.7944 29.3006 16.1258 29.3006C15.4591 29.3006 14.9185 28.76 14.9185 28.0923C14.9185 27.4247 15.4591 26.884 16.1258 26.884C16.7944 26.884 17.335 27.4247 17.335 28.0923Z"
                fill="currentColor"
            />
            <path
                d="M40.8599 11.9425H25.5088C24.9812 11.9425 24.5536 11.5148 24.5536 10.9873C24.5536 10.4598 24.9812 10.0322 25.5088 10.0322H40.8599C41.3874 10.0322 41.815 10.4598 41.815 10.9873C41.815 11.5148 41.3874 11.9425 40.8599 11.9425Z"
                fill="currentColor"
            />
            <path
                d="M40.8604 17.2853H33.3309C32.8034 17.2853 32.3758 16.8554 32.3758 16.3253C32.3758 15.7951 32.8034 15.3653 33.3309 15.3653H40.8604C41.3879 15.3653 41.8155 15.7951 41.8155 16.3253C41.8155 16.8554 41.3879 17.2853 40.8604 17.2853Z"
                fill="currentColor"
            />
            <path
                d="M25.4736 17.2853H29.3936C29.9017 17.2853 30.3136 16.8554 30.3136 16.3253C30.3136 15.7951 29.9017 15.3653 29.3936 15.3653H25.4736C24.9655 15.3653 24.5536 15.7951 24.5536 16.3253C24.5536 16.8554 24.9655 17.2853 25.4736 17.2853Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.6325 26.6372H42.9836C45.7452 26.6372 48 24.3824 48 21.6208V6.93636C48 4.17475 45.7452 1.91992 42.9836 1.91992H23.3839C20.6223 1.91992 18.3675 4.17475 18.3675 6.93636V15.8708H5.01548C2.25494 15.8708 0 18.1265 0 20.8872V35.5717C0 38.3331 2.25465 40.5881 5.01548 40.5881H22.3053L28.0604 45.4578C28.6812 45.9831 29.6325 45.5419 29.6325 44.7287V26.6372ZM25.6947 26.6372L19.9395 31.5061C19.3188 32.0312 18.3675 31.59 18.3675 30.7768V17.7811H5.01548C3.31011 17.7811 1.9103 19.1814 1.9103 20.8872V35.5717C1.9103 37.2782 3.30975 38.6778 5.01548 38.6778H22.6552C22.8811 38.6778 23.0997 38.7579 23.2721 38.9038L27.7222 42.6693V26.6372H25.6947ZM25.3448 24.7269C25.119 24.7269 24.9004 24.807 24.7279 24.9529L20.2778 28.7177V6.93636C20.2778 5.22978 21.6774 3.83022 23.3839 3.83022H42.9836C44.6901 3.83022 46.0897 5.22978 46.0897 6.93636V21.6208C46.0897 23.3274 44.6901 24.7269 42.9836 24.7269H25.3448Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default LiveChatIcon
